module.exports = __webpack_public_path__ + "static/img/アセット 36@2x.bc215d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 36@2x.png
// module id = Paux
// module chunks = 1